import React, { FunctionComponent } from 'react';

import { Alert } from 'src/components/alert';
import { i18n } from 'src/i18n';
import { errorImageProps } from 'src/resources/images';
import { I18nUtils } from 'src/utils/i18n-utils';
import { useProductsResponseQueryStateOrThrow } from 'src/hooks/use-products-query';

export const MaximumReachedAlert: FunctionComponent = (props) => {
  const { maxNumberOfUnits } = useProductsResponseQueryStateOrThrow();

  return (
    <Alert
      {...props}
      icon={errorImageProps}
      title={I18nUtils.message(i18n.component.error.maximumReachedAlert.title, { maximumStbs: maxNumberOfUnits })}
      text={i18n.component.error.maximumReachedAlert.subtitle}
    />
  );
};
